<div class="flex h-full flex-1 flex-col items-center justify-center">
    <img class="mb-8" [src]="'assets/shared-ui/images/sad-dinosaur.svg'" alt="No access icon" />
    <p class="text-[40px] leading-[52px]">{{ 'unauthorized.part1' | translate }}</p>
    <p class="text-[40px] leading-[52px]">{{ 'unauthorized.part2' | translate }}</p>
    <span class="text-[16px] leading-[28px] mt-5">
        {{ 'unauthorized.support' | translate }}
        <a [href]="'mailto:' + ('unauthorized.mail-to' | translate)" class="text-[rgb(var(--ui-2))]">{{
            'unauthorized.click-here' | translate
        }}</a>
    </span>
</div>
